<template>
    <div>
        <Card>
            <p slot="title"> Klaim </p>
            <div>
                <ButtonGroup>
                    <Button type="primary" size="large" @click="changeMarkingType('marking')">
                        <Icon type="ios-arrow-back"></Icon>
                        Marking
                    </Button>
                    <Button type="primary" size="large" @click="changeMarkingType('markingGroup')">
                        Marking Group
                        <Icon type="ios-arrow-forward"></Icon>
                    </Button>
                </ButtonGroup>

                <Row type="flex" justify="space-between" class="code-row-bg" style="margin-top: 10px;">
                    <Col span="12">
                    <transition name="move-right">
                        <div v-show="markingShow">
                            <ButtonGroup class="custom-group-parent">
                                <Button class="custom-group">Marking</Button>
                                <Select style="width: 250px;" v-model="markingIdSelected" filterable clearable
                                    :remote-method="getMarkingByCode" :loading="isLoadingMarking"
                                    @on-change="getClaimMarking()">
                                    <Option v-for="option in optionMarkings" :value="option.value" :key="option.value">
                                        {{ option.label }}</Option>
                                </Select>
                            </ButtonGroup>
                        </div>
                    </transition>

                    <transition name="move-right">
                        <div v-show="markingGroupShow">
                            <ButtonGroup class="custom-group-parent">
                                <Button class="custom-group">Marking Group</Button>
                                <Select style="width: 250px;" v-model="markingGroupIdSelected" filterable clearable
                                    :remote-method="getMarkingGroupByCode" :loading="isLoadingMarking"
                                    @on-change="changeMarkingGroupHandle()">
                                    <Option v-for="option in optionMarkingGroups" :value="option.value"
                                        :key="option.value">
                                        {{ option.label }}</Option>
                                </Select>
                            </ButtonGroup>
                        </div>
                    </transition>
                    </Col>
                    <Col span="12">
                    <Spin size="large" v-show="isLoadingMarking"></Spin>
                    </Col>
                </Row>
                <br />

                <Card v-show="markingShow">
                    <Table border :columns="columnsDataTable" :data="invoiceClaimData"
                        v-show="invoiceClaimData.length > 0"></Table>
                </Card>

                <Card v-show="markingGroupShow">
                    <button v-show="dataClaimSelected.length > 0" @click="showAddClaimHandle" type="button"
                        class="ivu-btn ivu-btn-success ivu-btn-small" style="margin-right: 5px;"> <span>Tambah claim: {{
                            dataClaimSelected.length }}</span></button>
                    <Tabs :animated="false" @on-click="groupClickHandle" v-model="markingActiveGroup">
                        <TabPane v-for="marking in listMarkingGroup" :key="marking.markingheaderid"
                            :label="marking.markingheadercode" :name="marking.markingheaderid.toString()">
                            <p slot="title"> Daftar Klaim </p>
                            <Table border :columns="columnsDataTableGroup" :data="invoiceClaimDataGroup"></Table>
                        </TabPane>
                    </Tabs>
                </Card>
            </div>
        </Card>

        <Modal v-model="isModalUploadFile" width="60%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Klaim</span>
            </p>
            <Form ref="formAdd" :model="formAdd" :rules="ruleValidateClaim">
                <Form-item label="Tanggal & No. Partai">
                    <Input v-model="formAdd.invoiceDateContainerCode" disabled></Input>
                    <Input style="display:none" v-model="formAdd.markingHeaderId"></Input>
                    <Input style="display:none" v-model="formAdd.receivableId"></Input>
                </Form-item>
                <FormItem>
                    <Row>
                        <Col span="8">
                        Tanggal Klaim
                        </Col>
                        <Col span="4" offset="1">
                        </Col>
                    </Row>
                </FormItem>
                <Form-item>
                    <Row>
                        <Col span="8">
                        <Date-picker v-model="formAdd.claimDate" disabled readonly style="width: 100%;" type="date"
                            placeholder="Tanggal Klaim" format="yyyy/MM/dd">
                        </Date-picker>
                        </Col>
                    </Row>
                </Form-item>
                <!-- <Form-item label="Kategori (Pastikan Sesuai)" prop="category">
                    <br>
                    <Select style="width:80%;display:revert" placeholder="Pilih Kategori Bank"
                         @on-change="changeCategory()" v-model="formAdd.category">
                        <Option v-for="category in categories" :value="category.id" :key="category.id">{{
                            category.value }}
                        </Option>
                    </Select>
                </Form-item> -->
                <Form-item label="Kode Penyesuaian" prop="categoryCodeId">
                    <br>
                    <Select
                        style="width:80%;display:revert"
                        v-model="formAdd.categoryCodeId"
                        placeholder="Select"
                        clearable
                        filterable>
                        <Option
                            v-for="category in categoriesCode"
                            :value="category.id"
                            :key="category.id">{{ category.category }}</Option>
                    </Select>
                </Form-item>
                <Form-item label="Bank" prop="bankAccountId">
                    <br>
                    <Select style="width:80%;display:revert" placeholder="Pilih Rekening Bank" filterable clearable
                        @on-change="changeBankAccount()" v-model="formAdd.bankAccountId">
                        <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">{{
                            bankAccount.accountName }}
                        </Option>
                    </Select>
                </Form-item>
                <FormItem>
                    <Row type="flex" justify="space-between">
                        <Col span="8">
                        Category Klaim
                        </Col>
                        <Col span="5">
                        Nilai Klaim
                        </Col>
                        <Col span="8">
                        Keterangan
                        </Col>
                        <Col span="2">
                        </Col>
                    </Row>
                </FormItem>
                <template v-for="(item, index) in formAdd.formDynamic.items">
                    <FormItem v-if="item.status" :key="index">
                        <Row type="flex" justify="space-between">
                            <Col span="8">
                            <Select
                              v-model="formAdd.formDynamic.items[index].categoryClaimId"
                              placeholder="Select"
                              clearable
                              filterable>
                                <Option
                                    v-for="categoryClaim in categoryClaims"
                                    :value="categoryClaim.id"
                                    :key="categoryClaim.id">  {{ `${categoryClaim.code}. ${categoryClaim.name} ` }}</Option>
                            </Select>
                            </Col>
                            <Col span="5">
                            <Money v-if="isSpecialMarking" v-model="formAdd.formDynamic.items[index].claimValue"
                                v-bind="moneySG" class="ivu-input">
                            </Money>
                            <Money v-else v-model="formAdd.formDynamic.items[index].claimValue" v-bind="money"
                                class="ivu-input">
                            </Money>
                            </Col>
                            <Col span="8">
                            <Input v-model="formAdd.formDynamic.items[index].description"></Input>
                            </Col>
                            <Col span="2">
                            <Button @click="handleRemove(index)" type="error">Delete</Button>
                            </Col>
                        </Row>
                    </FormItem>
                </template>
                <FormItem>
                    <Row type="flex" justify="space-between">
                        <Col span="7">
                        <Button type="info" @click="handleAdd"> + Tambah Nilai Klaim</Button>
                        </Col>
                        <Col span="14" v-show="claimValueTotal">
                        <b>
                            Total Nilai Klaim :
                            <span style="float:right">{{ claimValueTotal }} </span>
                        </b>
                        </Col>
                        <Col span="2">
                        </Col>
                    </Row>
                </FormItem>
                <!-- <Form-item label="Upload File" prop="file">
                <br>
                <Upload
                    type="drag"
                    ref="upload"
                    name="fileUploaded"
                    :action="this.serverUrlUploadFile"
                    :before-upload="handleBeforeUpload">
                    <div style="padding: 20px 0">
                        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                        <p>Click or drag files here to upload</p>
                    </div>
                </Upload>
                <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
            </Form-item> -->
            </Form>
            <div slot="footer">
                <Button type="primary" :loading="isLoadingUploadFile" @click="postUploadFile">
                    <span v-if="!isLoadingUploadFile">Simpan</span>
                    <span v-else>Uploading.....</span>
                </Button>
            </div>
        </Modal>


        <Modal v-model="isModalAddClaimGroup" width="50%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Tambah Klaim Group</span>
            </p>
            <Form ref="formAddGroup" :model="formAddGroup" :rules="ruleValidateClaim">
                <Form-item label="Tanggal Klaim">
                    <Date-picker v-model="formAddGroup.claimDate" disabled style="width: 75%; display:revert"
                        type="date" placeholder="Tanggal Klaim" format="yyyy/MM/dd">
                    </Date-picker>
                </Form-item>
                <!-- <Form-item label="Kategori" prop="category">
                    <br>
                    <Select style="width:80%;display:revert" placeholder="Pilih Kategori Bank"
                         @on-change="changeCategory()" v-model="formAddGroup.category">
                        <Option v-for="category in categories" :value="category.id" :key="category.id">{{
                            category.value }}
                        </Option>
                    </Select>
                </Form-item> -->
                <Form-item label="Kode Penyesuaian" prop="categoryCodeId">
                    <br>
                    <Select
                        style="width:80%;display:revert"
                        v-model="formAddGroup.categoryCodeId"
                        placeholder="Select"
                        clearable
                        filterable>
                        <Option
                            v-for="category in categoriesCode"
                            :value="category.id"
                            :key="category.id">{{ category.category }}</Option>
                    </Select>
                </Form-item>
                <Form-item label="Bank" prop="bankAccountId">
                    <br>
                    <Select style="width:80%;display:revert" placeholder="Pilih Rekening Bank" clearable
                        @on-change="changeBankAccount()" v-model="formAddGroup.bankAccountId">
                        <Option v-for="bankAccount in bankAccounts" :value="bankAccount.id" :key="bankAccount.id">{{
                            bankAccount.accountName }}
                        </Option>
                    </Select>
                </Form-item>
                <template v-for="(value, i) in formAddGroup.listClaim">
                    <Card>
                        <Form-item label="Tanggal & No. Partai">
                            <Input v-model="value.invoiceDateContainerCode" disabled></Input>
                            <Input style="display:none" v-model="value.markingHeaderId"></Input>
                            <Input style="display:none" v-model="value.receivableId"></Input>
                        </Form-item>
                        <Form-item label="Marking Header Code">
                            <Input v-model="value.markingHeaderCode" disabled></Input>
                        </Form-item>
                        <FormItem>
                            <Row type="flex" justify="space-between">
                                <Col span="8">
                                Category Klaim
                                </Col>
                                <Col span="5">
                                Nilai Klaim
                                </Col>
                                <Col span="8">
                                Keterangan
                                </Col>
                                <Col span="2">
                                </Col>
                            </Row>
                        </FormItem>
                        <template v-for="(item, index) in value.details">
                            <FormItem v-if="item.status" :key="index">
                                <Row type="flex" justify="space-between">
                                    <Col span="8">
                                      <Select
                                        v-model="item.categoryClaimId"
                                        placeholder="Select"
                                        clearable
                                        filterable>
                                          <Option
                                              v-for="categoryClaim in categoryClaims"
                                              :value="categoryClaim.id"
                                              :key="categoryClaim.id">  {{ `${categoryClaim.code}. ${categoryClaim.name} ` }}</Option>
                                      </Select>
                                    </Col>
                                    <Col span="5">
                                    <Money v-if="isSpecialMarking" v-model="item.claimValue" v-bind="moneySG"
                                        @focusout.native="changeClaimValue()" class="ivu-input">
                                    </Money>
                                    <Money v-else v-model="item.claimValue" v-bind="money"
                                        @focusout.native="changeClaimValue()" class="ivu-input">
                                    </Money>
                                    </Col>
                                    <Col span="8">
                                    <Input v-model="item.description"></Input>
                                    </Col>
                                    <Col span="2">
                                    <Button @click="handleRemoveClaimGroup(index, value.receivableId)"
                                        type="error">Delete</Button>
                                    </Col>
                                </Row>
                            </FormItem>
                        </template>
                        <FormItem>
                            <Row type="flex" justify="space-between">
                                <Col span="7">
                                <Button type="info" @click="handleAddClaimGroup(value.receivableId)"> + Tambah Nilai
                                    Klaim</Button>
                                </Col>
                                <Col span="14" v-show="value.claimValueTotal">
                                <b>
                                    Total Nilai Klaim :
                                    <Money v-if="isSpecialMarking" style="float:right" v-bind="moneySG"
                                        v-model="value.claimValueTotal" disabled>
                                    </Money>
                                    <Money v-else style="float:right" v-bind="money" v-model="value.claimValueTotal"
                                        disabled>
                                    </Money>
                                </b>
                                </Col>
                                <Col span="2">
                                </Col>
                            </Row>
                        </FormItem>
                    </Card>
                    <br>
                </template>
                <!-- <Form-item label="Upload File" prop="file">
                <br>
                <Upload
                    type="drag"
                    ref="upload"
                    name="fileUploaded"
                    :action="this.serverUrlUploadFile"
                    :before-upload="handleBeforeUpload">
                    <div style="padding: 20px 0">
                        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                        <p>Click or drag files here to upload</p>
                    </div>
                </Upload>
                <Progress :percent="pValue" :stroke-width="20" v-show="isProgress" />
            </Form-item> -->
            </Form>
            <div slot="footer">
                <Button type="primary" :loading="isLoadingUploadFile" @click="postClaimGroup">
                    <span v-if="!isLoadingUploadFile">Simpan</span>
                    <span v-else>Uploading.....</span>
                </Button>
            </div>
        </Modal>


        <Modal v-model="isModalDetail" width="50%">
            <p slot="header" style="color:#f60;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Detail</span>
            </p>
            <Form ref="formAdd" :model="formAdd">
                <Form-item label="Tanggal & No. Partai">
                    <Input v-model="formAdd.invoiceDateContainerCode" readonly></Input>
                    <Input style="display:none" v-model="formAdd.markingHeaderId"></Input>
                    <Input style="display:none" v-model="formAdd.receivableId"></Input>
                </Form-item>
                <Form-item label="Keterangan">
                    <Input v-model="formAdd.description" readonly></Input>
                </Form-item>
                <FormItem v-show="formAdd.claimDetail.length > 0">
                    <Row>
                        <Col span="10">
                        Nilai Klaim
                        </Col>
                        <Col span="12" offset="1">
                        Keterangan Klaim
                        </Col>
                    </Row>
                </FormItem>
                <template v-for="(item, index) in formAdd.claimDetail">
                    <FormItem>
                        <Row>
                            <Col span="10">
                            <Money v-if="isSpecialMarking" v-model="formAdd.claimDetail[index].claim_value"
                                v-bind="moneySG" class="ivu-input" readonly>
                            </Money>
                            <Money v-else v-model="formAdd.claimDetail[index].claim_value" v-bind="money"
                                class="ivu-input" readonly>
                            </Money>
                            </Col>
                            <Col span="12" offset="1">
                            <Input v-model="formAdd.claimDetail[index].description" readonly></Input>
                            </Col>
                        </Row>
                    </FormItem>
                </template>
                <FormItem>
                    <Row>
                        <Col span="10" offset="9">
                        <b>
                            Total Nilai Klaim :
                            <span style="float:right">{{ formAdd.totalClaim }}</span>
                        </b>
                        </Col>
                    </Row>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import { values } from 'lodash';
import moment from 'moment'
import { formats } from 'numeral';
import { Money } from 'v-money'
import { set } from 'vue';

const numeral = require('numeral');

export default {
    components: { Money },
    data() {
        return {
            money: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '',
                precision: 0,
                masked: false
            },
            moneySG: {
                decimal: '.',
                thousands: ',',
                prefix: '',
                suffix: '',
                precision: 2,
                masked: false
            },
            optionMarkings: [],
            optionMarkingGroups: [],
            markingIdSelected: '',
            markingGroupIdSelected: '',
            listMarkingGroup: [],
            isLoadingMarking: false,
            bankAccounts: [],
            categories: [
              {
                  id : 'MUTASI',
                  value : 'MUTASI'
              },
              {
                  id : 'PENYESUAIAN',
                  value : 'PENYESUAIAN'
              }
            ],
            categoryClaims: [],
            isSaveShow: false,
            isSaveShowGroup: false,
            ruleValidateClaim: {
                bankAccountId: [
                    { required: true, message: 'Pilih Bank Dahulu', trigger: 'blur' },
                ],
                categoryCodeId: [
                    { required: true, message: 'Kode Penyesuaian', trigger: 'blur' },
                ],
            },
            columnsDataTable: [
                {
                    title: 'Tanggal',
                    key: 'invoiceDate'
                },
                {
                    title: 'No. Container',
                    key: 'containerNumber'
                },
                {
                    title: 'Keterangan',
                    key: 'description'
                },
                {
                    title: 'Invoice Fee',
                    key: 'invoice_fee'
                },
                {
                    title: 'Total Nilai Klaim',
                    key: 'total_claim'
                },
                // {
                //     title: 'File',
                //     key: 'file',
                //     align: 'center',
                //     render: (h, params) => {
                //         const { row } = params

                //         return h('div', [
                //             h('a', {
                //                 style: {
                //                     textDecoration: 'underline'
                //                 },
                //                 on: {
                //                     click: () => {
                //                         this.downloadFile(row.markingHeaderCode, row.file)
                //                     }
                //                 }
                //             }, row.file)
                //         ]);
                //     }
                // },
                {
                    title: 'Action',
                    key: 'action',
                    width: 200,
                    align: 'center',
                    render: (h, params) => {
                        let { row } = params;
                        let invoiceFeeInt = parseInt(row.invoice_fee.replace("Rp. ", "").replace(/,/g, ""));
                        let totalClaimInt = parseInt(row.total_claim.replace("Rp. ", "").replace(/,/g, ""));
                        // let setDisable = invoiceFeeInt <= totalClaimInt
                        let setDisable = false

                        return h('div', [
                            setDisable
                                ? h('Tooltip', {
                                    props: {
                                        content: "Klaim mencapai invoice",
                                        placement: 'left',
                                    },
                                }, [
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            size: 'small',
                                            disabled: true,
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                    }, 'Tambah')
                                ])
                                : h('Button', {
                                    props: {
                                        type: 'success',
                                        size: 'small',
                                        disabled: false,
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.showUploadFile(params.index)
                                        }
                                    }
                                }, 'Tambah')
                        ])
                    },
                },

            ],
            columnsDataTableGroup: [
                {
                    title: 'Tanggal',
                    key: 'invoiceDate'
                },
                {
                    title: 'No. Container',
                    key: 'containerNumber'
                },
                {
                    title: 'Keterangan',
                    key: 'description'
                },
                {
                    title: 'Invoice Fee',
                    key: 'invoice_fee'
                },
                {
                    title: 'Total Nilai Klaim',
                    key: 'total_claim'
                },
                // {
                //     title: 'File',
                //     key: 'file',
                //     align: 'center',
                //     render: (h, params) => {
                //         const { row } = params

                //         return h('div', [
                //             h('a', {
                //                 style: {
                //                     textDecoration: 'underline'
                //                 },
                //                 on: {
                //                     click: () => {
                //                         this.downloadFile(row.markingHeaderCode, row.file)
                //                     }
                //                 }
                //             }, row.file)
                //         ]);
                //     }
                // },
                {
                    title: 'Action',
                    key: 'action',
                    width: 200,
                    align: 'center',
                    render: (h, params) => {
                        let { row } = params;
                        // console.info(row.selected)
                        return h('div', [
                            h('Button', {
                                props: {
                                    type: row.selected ? 'warning' : 'success',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '5px'
                                },
                                on: {
                                    click: () => {
                                        this.handleSelectMarking(params.index)
                                    }
                                }
                            }, row.selected ? 'Selected' : 'Select'),
                        ]);
                    }
                },
            ],
            invoiceClaimData: [],
            invoiceClaimDataGroup: [],
            dataClaimSelected: [],
            isModalUploadFile: false,
            isModalAddClaimGroup: false,
            isModalDetail: false,
            isLoadingUploadFile: false,
            formAdd: {
                index: 1,
                formDynamic: {
                    items: [
                        {
                            index: 1,
                            status: 1,
                            claimValue: '',
                            description: '',
                        }
                    ]
                },
                categoryCodeId: null,
                claimDate: moment(new Date()).format('YYYY/MM/DD'),
                claimDetail: [],
                categoryClaimId: null,
            },
            formAddGroup: {
                claimDate: moment(new Date()).format('YYYY/MM/DD'),
                markingGroupId: 0,
                bankAccountId: 0,
                category: 'MUTASI',
                listClaim: [],
            },
            serverUrlUploadFile: "",
            isProgress: false,
            pValue: 0,
            markingShow: false,
            markingGroupShow: false,
            markingActiveGroup: "",
            isSpecialMarking: false,
            categoriesCode: [],
            categoryCodeId: null,
            isAdjustment: false,
        }
    },
    methods: {
        getMarkingByCode: _.debounce(
            function (query) {
                query = query.trim();
                if (query !== '') {
                    this.isLoadingMarking = true;
                    HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query
                        })
                        .then(response => {
                            this.isLoadingMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.isLoadingMarking = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkings = [];
                }
            }, 400
        ),
        getMarkingGroupByCode: _.debounce(
            function (query) {
                query = query.trim();
                if (query !== '') {
                    this.isLoadingMarking = true;
                    HTTP
                        .post('markingGroup/getByCode', {
                            groupName: query
                        })
                        .then(response => {
                            this.isLoadingMarking = false;
                            let data = response.data;

                            const list = data.map(item => {

                                return {
                                    value: item.id,
                                    label: item.code,
                                    detail: item.detail
                                };
                            });

                            this.optionMarkingGroups = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                        })
                        .catch(e => {
                            this.isLoadingMarking = false;
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                } else {
                    this.optionMarkingGroups = [];
                }
            }, 400
        ),
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        changeMarkingGroupHandle: function () {
            if (this.markingGroupIdSelected) {
                this.listMarkingGroup = this.optionMarkingGroups[0].detail
                this.getClaimMarkingGroup(this.listMarkingGroup[0].markingheaderid)
                this.markingActiveGroup = this.listMarkingGroup[0].markingheaderid.toString()
                this.formAddGroup.markingGroupId = this.markingGroupIdSelected
                this.dataClaimSelected = []
            } else {
                this.listMarkingGroup = []
            }
        },

        getClaimMarking: function () {
            let parent = this;

            if (this.markingIdSelected == '') {
                return;
            }

            let marking = parent.optionMarkings.filter(item => item.value == parent.markingIdSelected)
            console.info('getClaimMarking', parent.optionMarkings)
            if (marking.length > 0) {
                let prefixMarking = marking[0].label.split("/")[0]
                parent.isSpecialMarking = prefixMarking == 'SBR' || prefixMarking == 'SBRT' || prefixMarking == 'CTH'
            } else {
                parent.isSpecialMarking = false
            }

            this.isLoadingMarking = true;

            HTTP.get('receivable/claim/' + this.markingIdSelected)
                .then(response => {
                    let invoiceClaim = []
                    _.forEach(response.data, function (value, index) {
                        let listClaim = value.claims
                        let claimGroups = value.claim_group
                        let total_claim = 0

                        if (listClaim.length != 0) {
                            _.forEach(listClaim, function (value, index) {
                              console.log(value.total_claim);

                                if (value.isDeleted == 0) {
                                    total_claim += parseInt(value.total_claim)
                                }
                            });
                        }

                        if (claimGroups.length != 0) {
                            _.forEach(claimGroups, function (value, index) {
                                if (value.isDeleted == 0) {
                                    total_claim += parseInt(value.total_claim)
                                }
                            });
                        }

                        let currency = value.invoice != null ? value.invoice.currency : value.currency
                        if (currency !== 'SGD' && currency !== 'BAHT') {
                            currency = "Rp"
                        }
                        console.info(parent.isSpecialMarking)
                        if (parent.isSpecialMarking) {
                            total_claim = currency + ". " + numeral(total_claim).format('0,0.00')
                        } else {
                            total_claim = currency + ". " + numeral(total_claim).format('0,0')
                        }

                        let invoiceDate = value.invoice != null ? parent.showDateFormatted(value.invoice.invoicedate) : parent.showDateFormatted(value.transactionDate)
                        let containerNumber = value.invoice != null ? value.invoice.packaging_list.container_loading.containernumber : '-'
                        let containerCode = value.invoice != null ? value.invoice.packaging_list.container_loading.containercode : ''
                        let invoice_fee = 0
                        if (parent.isSpecialMarking) {
                            invoice_fee = value.invoice != null ? currency + ". " + numeral(value.invoice.invoicefee).format('0,0.00') : currency + ". " + numeral(value.debitAmount).format('0,0.00');
                        } else {
                            invoice_fee = value.invoice != null ? currency + ". " + numeral(value.invoice.invoicefee).format('0,0') : currency + ". " + numeral(value.debitAmount).format('0,0');
                        }

                        // let total_claim = value.claim != null ? "Rp. " + numeral(value.claim.total_claim).format('0,0') : '';
                        let description = value.description != null ? value.description : '';
                        // let fileName = value.claim != null ? value.claim.filename : '';
                        // let claim_detail = value.claim != null ? value.claim.claim_detail : '';

                        let iClaim = {
                            receivableId: value.id,
                            markingHeaderId: value.markingHeaderId,
                            markingHeaderCode: value.marking_header.markingheadercode,
                            invoiceDate: invoiceDate,
                            containerNumber: containerNumber,
                            containerCode: containerCode,
                            invoice_fee: invoice_fee,
                            total_claim: total_claim,
                            description: description,
                            // file : fileName,
                            // claim_detail : claim_detail
                        }
                        invoiceClaim.push(iClaim);
                    });

                    this.invoiceClaimData = invoiceClaim;
                    this.isLoadingMarking = false;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });

        },
        getClaimMarkingGroup: function (markingId) {
            let parent = this;

            this.isLoadingMarking = true;

            let marking = parent.optionMarkingGroups.filter(item => item.value == parent.markingGroupIdSelected)
            console.info(marking)
            if (marking.length > 0) {
                let prefixMarking = marking[0].label.split("/")[0]
                parent.isSpecialMarking = prefixMarking == 'SBR' || prefixMarking == 'SBRT' || prefixMarking == 'CTH'
            } else {
                parent.isSpecialMarking = false
            }

            HTTP.get('receivable/claim/' + markingId)
                .then(response => {
                    let invoiceClaim = []
                    _.forEach(response.data, function (value, index) {
                        let listClaim = value.claims
                        let claimGroups = value.claim_group
                        let total_claim = 0

                        if (listClaim.length != 0) {
                            total_claim = 0
                            _.forEach(listClaim, function (value, index) {
                                if (value.isDeleted == 0) {
                                    total_claim += value.total_claim
                                }
                            });
                        }

                        if (claimGroups.length != 0) {
                            _.forEach(claimGroups, function (value, index) {
                                if (value.isDeleted == 0) {
                                    total_claim += value.total_claim
                                }
                            });
                        }

                        let currency = value.invoice != null ? value.invoice.currency : value.currency
                        if (currency !== 'SGD' && currency !== 'BAHT') {
                            currency = "Rp"
                        }

                        if (parent.isSpecialMarking) {
                            total_claim = currency + ". " + numeral(total_claim).format('0,0.00')
                        } else {
                            total_claim = currency + ". " + numeral(total_claim).format('0,0')
                        }

                        let invoiceDate = value.invoice != null ? parent.showDateFormatted(value.invoice.invoicedate) : parent.showDateFormatted(value.transactionDate)
                        let containerNumber = value.invoice != null ? value.invoice.packaging_list.container_loading.containernumber : '-'
                        let containerCode = value.invoice != null ? value.invoice.packaging_list.container_loading.containercode : ''
                        let invoice_fee = 0
                        if (parent.isSpecialMarking) {
                            invoice_fee = value.invoice != null ? currency + ". " + numeral(value.invoice.invoicefee).format('0,0.00') : currency + ". " + numeral(value.debitAmount).format('0,0.00');
                        } else {
                            invoice_fee = value.invoice != null ? currency + ". " + numeral(value.invoice.invoicefee).format('0,0') : currency + ". " + numeral(value.debitAmount).format('0,0');
                        }

                        // let total_claim = value.claim != null ? "Rp. " + numeral(value.claim.total_claim).format('0,0') : '';
                        let description = value.description != null ? value.description : '';
                        // let fileName = value.claim != null ? value.claim.filename : '';
                        // let claim_detail = value.claim != null ? value.claim.claim_detail : '';

                        let iClaim = {
                            receivableId: value.id,
                            markingHeaderId: value.markingHeaderId,
                            markingHeaderCode: value.marking_header.markingheadercode,
                            invoiceDate: invoiceDate,
                            containerNumber: containerNumber,
                            containerCode: containerCode,
                            invoice_fee: invoice_fee,
                            total_claim: total_claim,
                            description: description,
                            // file : fileName,
                            // claim_detail : claim_detail,
                        }

                        let isSelected = parent.dataClaimSelected.some(item => item.receivableId === iClaim.receivableId)
                        if (isSelected) {
                            iClaim.selected = true
                        } else {
                            iClaim.selected = false
                        }

                        invoiceClaim.push(iClaim);
                    });

                    this.invoiceClaimDataGroup = invoiceClaim;
                    this.isLoadingMarking = false;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        showUploadFile: function (index) {
            var receivableId = this.invoiceClaimData[index].receivableId;
            var markingHeaderId = this.invoiceClaimData[index].markingHeaderId;
            var markingHeaderCode = this.invoiceClaimData[index].markingHeaderCode;
            // var fileName = this.invoiceClaimData[index].fileName;
            var invoiceDate = this.invoiceClaimData[index].invoiceDate;
            var containerCode = this.invoiceClaimData[index].containerCode;
            var claimValue = this.invoiceClaimData[index].claimValue;

            this.formAdd.receivableId = receivableId;
            this.formAdd.markingHeaderId = markingHeaderId;
            this.formAdd.markingHeaderCode = markingHeaderCode;
            // this.formAdd.fileName = fileName;
            this.formAdd.invoiceDateContainerCode = invoiceDate + ' - P. ' + containerCode;
            this.formAdd.claimValue = claimValue;

            this.isModalUploadFile = true;
        },
        handleAdd() {
            this.formAdd.index++;
            this.formAdd.formDynamic.items.push({
                index: this.formAdd.index,
                status: 1,
                claimValue: '',
                description: '',
                categoryClaimId: null,
            });
        },
        handleAddClaimGroup(receivableId) {
            this.formAddGroup.listClaim.map((value, index) => {
                if (value.receivableId === receivableId) {
                    let items = value.details
                    items.push({
                        status: 1,
                        claimValue: '',
                        description: '',
                        categoryClaimId: null
                    })
                }
            })
        },
        handleRemove(index) {
            this.formAdd.formDynamic.items[index].status = 0;
            this.claimValueTotal - this.formAdd.formDynamic.items[index].claimValue;
        },
        handleRemoveClaimGroup(index, receivableId) {
            this.formAddGroup.listClaim.map((value) => {
                if (value.receivableId === receivableId) {
                    if (index >= 0 && index < value.details.length) {
                        value.details.splice(index, 1);
                    }
                }
            })
            this.changeClaimValue()
        },
        // handleBeforeUpload (file) {
        //     console.log({file});

        //     const formData = new FormData();
        //     formData.append('file', file);
        //     formData.append('markingHeaderCode', this.formAdd.markingHeaderCode);

        //     this.isProgress = true;
        //     this.pValue = Math.floor(Math.random() * 100); // Returns a random integer from 0 to 99:

        //     HTTP
        //     .post('/claim/file/upload', formData, {
        //        headers: {
        //         'Content-Type': 'multipart/form-data',
        //       },
        //     })
        //     .then(response => {
        //         console.log("claim upload response :", response);
        //         this.formAdd.fileName = response.data.filename; // Set filename
        //         // this.isProgress = false;
        //         this.pValue = 100;
        //     })
        //     .catch(e => {
        //         this.$Notice.error({
        //             title: "Error",
        //             desc:e,
        //             duration: 5
        //         });
        //     })

        //     return false; // Kembalikan false untuk mencegah unggahan otomatis
        // },
        postUploadFile: function () {
            this.isLoadingUploadFile = true;
            this.$Loading.start();

            if(this.formAdd.categoryCodeId == null) {
                this.$Message.info('Silahkan Pilih Kode Penyesuaian !');

                this.$Loading.finish();
                this.isLoadingUploadFile = false;
                return;
            }

            let claimDetails = [];
            let isCategoryClaimMissing = false;
            _.forEach(this.formAdd.formDynamic.items, function (value, index) {
                if (value.status) {
                    if(!value.categoryClaimId) {
                        isCategoryClaimMissing = true;
                    }

                    let claim = {
                        claimValue: value.claimValue,
                        description: value.description,
                        categoryClaimId: value.categoryClaimId,
                    }

                    claimDetails.push(claim);
                }
            });

            if (isCategoryClaimMissing) {
                this.$Message.info('Silahkan Pilih Category Claim !');

                this.$Loading.finish();
                this.isLoadingUploadFile = false;
                return;
            }

            this.formAdd.claimDate = moment(new Date()).format('YYYY/MM/DD');

            let payload = {
                receivableId: this.formAdd.receivableId,
                markingHeaderId: this.formAdd.markingHeaderId,
                claim_date: moment(this.formAdd.claimDate).format('YYYY/MM/DD'),
                bankAccountId: this.formAdd.bankAccountId,
                // category: this.formAdd.category,
                categoryCodeId: this.formAdd.categoryCodeId,
                totalClaim: this.claimValueTotal.replace(/[^\d.]/g, ''),
                claimDetails: claimDetails
            }

            HTTP
                .post('/claim', payload)
                .then(response => {

                    this.isModalUploadFile = false;
                    this.isLoadingUploadFile = false;
                    this.$Loading.finish();
                    this.$Message.success('Claim updated !');

                    this.getClaimMarking();
                    console.info(this.optionMarkings)
                })
                .catch(e => {

                  this.$Loading.finish();
                  this.isLoadingUploadFile = false;

                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getBankAccount: function () {
            HTTP.get("bankAccount/findAll/active")
                .then(response => {
                    this.bankAccounts = response.data;
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });
        },
        changeBankAccount() {
            if (this.formAdd.bankAccountId) {
                this.isSaveShow = true
            }

            if (this.formAddGroup.bankAccountId) {
                this.isSaveShowGroup = true
            }
        },
        changeCategory() {
            if (this.formAdd.category == "PENYESUAIAN") {
                this.isAdjustment = true
            } else {
                this.isAdjustment = false
            }
        },
        changeClaimValue() {
            // console.info(this.formAddGroup.listClaim)
            this.formAddGroup.listClaim.map(claim => {
                let totalClaim = 0
                claim.details.forEach(value => {
                    totalClaim += value.claimValue
                });
                return claim.claimValueTotal = totalClaim
            })
            console.info(this.formAddGroup)
        },
        // downloadFile: function(markingHeaderCode, fileName) {
        //     let payload = {
        //         markingHeaderCode : markingHeaderCode,
        //         filename : fileName
        //     }

        //     console.log({payload});
        //     HTTP
        //     .post('claim/file/download', payload, { responseType: 'blob' })
        //     .then(response => {
        //         console.log({response});
        //         // window.open(URL.createObjectURL(response.data));

        //         let a = document.createElement("a");
        //         let url = window.URL.createObjectURL(response.data);

        //         document.body.appendChild(a);
        //         a.style = "display: none";
        //         a.href = url;
        //         a.download = fileName;
        //         a.click();
        //         window.URL.revokeObjectURL(url);
        //     })
        //     .catch(e => {
        //         this.$Notice.error({
        //             title: "Error",
        //             desc:e,
        //             duration: 5
        //         });
        //     })
        // },
        showModalDetail: function (index) {

            var receivableId = this.invoiceClaimData[index].receivableId;
            var markingHeaderId = this.invoiceClaimData[index].markingHeaderId;
            var markingHeaderCode = this.invoiceClaimData[index].markingHeaderCode;
            // var fileName = this.invoiceClaimData[index].fileName;
            var invoiceDate = this.invoiceClaimData[index].invoiceDate;
            var containerCode = this.invoiceClaimData[index].containerCode;
            var totalClaim = this.invoiceClaimData[index].total_claim;
            var description = this.invoiceClaimData[index].description;
            var claimDetail = this.invoiceClaimData[index].claim_detail;

            this.formAdd.receivableId = receivableId;
            this.formAdd.markingHeaderId = markingHeaderId;
            this.formAdd.markingHeaderCode = markingHeaderCode;
            // this.formAdd.fileName = fileName;
            this.formAdd.invoiceDateContainerCode = invoiceDate + ' - P. ' + containerCode;
            this.formAdd.totalClaim = totalClaim;
            this.formAdd.description = description;
            this.formAdd.claimDetail = claimDetail;
            console.info("halo", this.formAdd)
            this.isModalDetail = true;
        },
        changeMarkingType: function (type) {
            if (type == "marking") {
                this.markingShow = true
                this.markingGroupShow = false
            } else if (type == "markingGroup") {
                this.markingShow = false
                this.markingGroupShow = true
            }
        },
        groupClickHandle: function (indexTab) {
            this.invoiceClaimDataGroup = []
            this.getClaimMarkingGroup(indexTab)
        },
        handleSelectMarking: function (index) {
            let isClaimInArray = this.dataClaimSelected.some(item => item['receivableId'] === this.invoiceClaimDataGroup[index].receivableId)
            if (isClaimInArray) { // jika sudah ada di hapus
                this.dataClaimSelected = this.dataClaimSelected.filter(item => item.receivableId !== this.invoiceClaimDataGroup[index].receivableId)
                this.invoiceClaimDataGroup[index].selected = false
            } else { // jika belum ada, ditambahkan
                this.dataClaimSelected.push(this.invoiceClaimDataGroup[index])
                this.invoiceClaimDataGroup[index].selected = true
            }
        },
        showAddClaimHandle: function () {
            let claimform = []
            this.dataClaimSelected.forEach((value, index) => {
                let tempClaim = {
                    details: [
                        {
                            status: 1,
                            claimValue: '',
                            description: '',
                            categoryClaimId: null
                        },
                    ],
                    receivableId: value.receivableId,
                    markingHeaderId: value.markingHeaderId,
                    markingHeaderCode: value.markingHeaderCode,
                    claimValueTotal: 0,
                    invoiceDateContainerCode: value.invoiceDate + ' - P. ' + value.containerCode
                }
                claimform.push(tempClaim)
            })
            this.formAddGroup.listClaim = claimform
            this.isModalAddClaimGroup = true
            console.info(this.formAddGroup)
        },
        getCategories: function() {
          HTTP.get("category/adjustment")
          .then(response => {
            this.categoriesCode = response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
        },
        getCategoryClaims: function() {
          HTTP.get("claim/categories")
          .then(response => {
            console.log({response});

            this.categoryClaims = response.data;
          })
          .catch(e => {
            this.$Notice.error({
              title: "Error",
              desc: e,
              duration: 5
            });
          });
        },
        postClaimGroup: function () {

            this.isLoadingUploadFile = true;
            this.$Loading.start();

            let listClaim = [];

            this.formAddGroup.listClaim.forEach(claim => {
                let details = []
                claim.details.forEach(value => {

                    if (value.claimValue) {
                        let obj = {
                            claimValue: value.claimValue,
                            description: value.description,
                            categoryClaimId: value.categoryClaimId
                        }
                        details.push(obj)
                    }
                })

                let tempClaim = {
                    markingHeaderId: claim.markingHeaderId,
                    receivableId: claim.receivableId,
                    totalClaim: claim.claimValueTotal,
                    details: details
                }

                listClaim.push(tempClaim)
            })

            this.formAddGroup.claimDate = moment(new Date()).format('YYYY/MM/DD');

            let payload = {
                markingGroupId: this.formAddGroup.markingGroupId,
                claim_date: moment(this.formAddGroup.claimDate).format('YYYY/MM/DD'),
                bankAccountId: this.formAddGroup.bankAccountId,
                // category: this.formAddGroup.category,
                listClaim: listClaim
            }

            HTTP
                .post('/claimGroup', payload)
                .then(response => {

                    this.isModalAddClaimGroup = false;
                    this.isLoadingUploadFile = false;
                    this.$Loading.finish();
                    this.$Message.success('Claim updated !');

                    this.afterPostClaimGroup()
                })
                .catch(e => {
                    console.info(e)
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        afterPostClaimGroup: function () {
            if (this.markingGroupIdSelected) {
                this.getClaimMarkingGroup(this.listMarkingGroup[0].markingheaderid)
                this.markingActiveGroup = this.listMarkingGroup[0].markingheaderid.toString()
                this.formAddGroup.markingGroupId = this.markingGroupIdSelected
                this.dataClaimSelected = []
            } else {
                this.listMarkingGroup = []
            }
        },
    },
    mounted() {
        this.markingShow = true
        this.getBankAccount();
        this.getCategoryClaims();
        if (this.categories.length > 0) {
          this.formAdd.category = this.categories[0].id;
        }
        this.$Loading.config({
            color: '#fff',
            failedColor: '#f0ad4e',
            height: 10
        });
    },
    created() {
        this.formAdd.claimDate = moment(new Date()).format('YYYY/MM/DD');
        this.getCategories();
    },
    computed: {
        claimValueTotal: function () {
            let claimTotal = 0;
            _.forEach(this.formAdd.formDynamic.items, function (value, index) {
                if (value.status) {
                    claimTotal += value.claimValue;
                }
            });

            return claimTotal != 0 ? numeral(claimTotal).format('0,0.00') : false;
        }
    }
}

</script>



// WEBPACK FOOTER //
// Claim.vue?0de16132